module.exports = __webpack_public_path__ + "static/scrye-logo-5f0a6f9309cdfc80e7e7b9cb19aeb53a.png";